// Функция создаёт промис и возращает его вместе с функцией ресолвером
// Моя старая реализация метода Promise.withResolvers
export function createPromiseWithResolver<T = void>(): {promise: Promise<T>, resolver: (prop: T) => void, reject: (reason?: any) => void} {
	let resolver = null;
	let reject = null;
	const promise = new Promise<T>((done, rej) => {
		resolver = done;
		reject = rej;
	});
	return {promise, resolver: resolver as any, reject: reject as any};
}
